import queryString from "query-string";
import { openIdAddress } from "../model/FetchAddresses";

const fetchDiscoveryDocumentAsync = async (): Promise<any> => {
  const response = await fetch(openIdAddress);
  const json = await response.json();
  return json;
};

const fetchDeviceRequestAuthorizationAsync = async (
  address: string,
  noRefresh?: boolean
): Promise<any> => {
  const params = {
    scope: `openid${!noRefresh ? ' offline_access' : ''} profile email`,
    client_id: "device",
  }

  const response = await fetch(address, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: queryString.stringify(params),
  });

  const json = await response.json();

  return json;
};

const fetchRequestDeviceTokenAsync = async (address: string, deviceCode: string): Promise<any> => {
  const params = {
    client_id: "device",
    device_code: deviceCode,
    grant_type: "urn:ietf:params:oauth:grant-type:device_code",
  };

  const response = await fetch(address, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: queryString.stringify(params),
  });

  return response;
};

export {
  fetchDiscoveryDocumentAsync,
  fetchDeviceRequestAuthorizationAsync,
  fetchRequestDeviceTokenAsync,
};
